import { getAuth } from "firebase/auth";
import { fetchData, postData } from "../../../services/api";

export const getPreferences = async () => {
  try {
    return await fetchData("video/preferences");
  } catch (error) {
    console.error("Error fetching preferences:", error);
    throw error;
  }
};

export const processAndUploadVideo = async (videoBlob, questionId) => {
  // Compress video (using Web Workers)
  // const compressedBlob = await compressVideo(videoBlob);

  // first ensure user is authenticated and get user id
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      // Try to reload the user
      await auth.currentUser?.reload();
      if (!auth.currentUser) {
        throw new Error("User not authenticated. Please sign in again.");
      }
    }

    // Force token refresh to ensure we have a valid token
    const idToken = await auth.currentUser.getIdToken(true);

    // Convert Blob to proper video file
    const videoFile = new File(
      [videoBlob],
      `question-${questionId}-${Date.now()}.webm`,
      {
        type: "video/webm",
        lastModified: Date.now(),
      }
    );

    const formData = new FormData();
    formData.append("video", videoFile);
    formData.append("questionId", questionId);

    console.log("Uploading video file:", {
      name: videoFile.name,
      type: videoFile.type,
      size: videoFile.size,
      lastModified: videoFile.lastModified,
    });

    return await postData("video/upload-video", formData, {
      headers: {
        Authorization: `Bearer ${idToken}`,
        // Let the browser set the Content-Type with boundary
      },
    });
  } catch (error) {
    console.error("Error uploading video:", error);
    if (error.code === "auth/invalid-refresh-token") {
      // Handle token refresh error
      throw new Error("Your session has expired. Please sign in again.");
    }
    throw error;
  }
};
